import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

import { isCoordinatePairValid } from "../models/CoordinatesPair";

@ValidatorConstraint({ name: "is Geo Json Polygon Coordinates" })
export class IsGeoJsonGeofenceCoordinates
  implements ValidatorConstraintInterface
{
  public validate(value: any): boolean {
    if (!Array.isArray(value)) {
      return false;
    }
    if (value.length !== 1) {
      return false;
    }
    const coordinatesCollection = value[0];

    // Polygon is created from at least 4 coordinate pairs
    if (
      !Array.isArray(coordinatesCollection) ||
      coordinatesCollection.length <= 3
    ) {
      return false;
    }

    const openingCoordinates = coordinatesCollection[0];
    const closingCoordinates =
      coordinatesCollection[coordinatesCollection.length - 1];
    // Polygon must be a closed loop
    if (
      openingCoordinates[0] !== closingCoordinates[0] ||
      openingCoordinates[1] !== closingCoordinates[1]
    ) {
      return false;
    }

    const allCoordinatesAreValid = coordinatesCollection.every(
      isCoordinatePairValid
    );
    return allCoordinatesAreValid;
  }

  public defaultMessage(): string {
    return "Invalid Geo JSON Polygon format.";
  }
}
